var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn"},[_c('div',{staticClass:"more_button"},[_c('div',[(!_vm.loading)?_c('a',{attrs:{"href":_vm.button_href}},[_vm._v(_vm._s(_vm.button_text))]):_c('i',{staticClass:"fa fa-spinner fa-spin fa-1x fa-fw"})])])])}
var staticRenderFns = []

export { render, staticRenderFns }